import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';

import App from './App';
import './fonts.css';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
